
export default {

    install(Vue) {

        // ELEMENT UI.

        // Components.
        Vue.component('el-input', require('element-ui').Input);
        Vue.component('el-select', require('element-ui').Select);
        Vue.component('el-option', require('element-ui').Option);


        // BLACK DASHBOARD PRO.

        // Plugins.        
        Vue.use(require('@tim/black-pro/src/components/NotificationPlugin').default);

        // Directives.
        Vue.directive('click-outside', require('@tim/black-pro/src/directives/click-ouside.js').default);

        // Components.
        Vue.component('badge', require('@tim/black-pro/src/components/Badge.vue').default);
        Vue.component('base-alert', require('@tim/black-pro/src/components/BaseAlert.vue').default);
        Vue.component('base-button', require('@tim/black-pro/src/components/BaseButton.vue').default);
        Vue.component('base-checkbox', require('@tim/black-pro/src/components/Inputs/BaseCheckbox.vue').default);
        Vue.component('base-radio', require('@tim/black-pro/src/components/Inputs/BaseRadio.vue').default);
        Vue.component('base-table', require('@tim/black-pro/src/components/BaseTable.vue').default);
        Vue.component('breadcrumb', require('@tim/black-pro/src/components/Breadcrumb/Breadcrumb.vue').default);
        Vue.component('breadcrumb-item', require('@tim/black-pro/src/components/Breadcrumb/BreadcrumbItem.vue').default);
        Vue.component('card', require('@tim/black-pro/src/components/Cards/Card.vue').default);
        Vue.component('collapse', require('@tim/black-pro/src/components/Collapse/Collapse.vue').default);
        Vue.component('collapse-item', require('@tim/black-pro/src/components/Collapse/CollapseItem.vue').default);
        Vue.component('tabs', require('@tim/black-pro/src/components/Tabs/Tabs.vue').default);
        Vue.component('tab-pane', require('@tim/black-pro/src/components/Tabs/Tab.vue').default);

        
        // LOCAL.

        // Components.
        Vue.component('base-input', require('./app/components/Inputs/BaseInput.vue').default);
        Vue.component('modal', require('./app/components/Modal.vue').default);
        Vue.component('modal-confirm', require('./app/components/ModalConfirm.vue').default);
        Vue.component('back-to-top', require('./app/components/BackToTop.vue').default);
        Vue.component('table-control', require('./app/components/TableControl.vue').default);
        Vue.component('table-pagination', require('./app/components/TablePagination.vue').default);
        Vue.component('base-select', require('./app/components/BaseSelect.vue').default);
        Vue.component('json-viewer', require('./app/components/JsonViewer.vue').default);
        Vue.component('context-filters', require('./app/components/ContextFilters.vue').default);

        // Content.
        Vue.component('brand', require('./app/contents/Brand.vue').default);
        Vue.component('brand-footer', require('./app/contents/BrandFooter.vue').default);

        // Customized components...
        // - Removed data-toggle="dropdown" on line 16 because dropdown didn't open on first click.
        Vue.component('base-dropdown', require('./app/components/BaseDropdown.vue').default);
        // - CurrentPage was set to 1 for each total change.
        Vue.component('base-pagination', require('./app/components/BasePagination.vue').default);

    }
}
